<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandle from "./DesignerQuestionHardwareHandle.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandle,
            SynsealQuestion,
        ],
    }
</script>
